module.exports = __webpack_public_path__ + "static/img/active-course-text.6cc0dc4c.png";